import { MARKET } from './market';

export const LOCATION_SEARCH_DATA_LOCAL_STORAGE_KEY = 'locationSearchData';
export const ZIPCODE_DATA_LOCAL_STORAGE_KEY = 'ZipCodeData';
export const MICROKERNEL_STORE_DEALER_KEY = 'dbadDealerStore';
export const LOCATION_SEARCH_DATA_CHANGE_EVENT = 'LOCATION_SEARCH_DATA_CHANGED';
export const LOCATION_SEARCH_MODAL_OPEN_EVENT = 'LOCATION_SEARCH_MODAL_OPEN';

const dealerId = new URLSearchParams(window.location.search).get('dealer') ?? undefined;

export const PARTNER_KVPS_SYNC_ID =
  dealerId === undefined || dealerId?.length < 5 || dealerId?.length > 7 ? undefined : dealerId;

export const RAW_PARTNER_ID =
  new URLSearchParams(window.location.search).get('partner_id') ?? undefined;

export const PARTNER_ID =
  MARKET === 'USA' && RAW_PARTNER_ID && RAW_PARTNER_ID.length > 5
    ? RAW_PARTNER_ID.slice(1)
    : RAW_PARTNER_ID;

export const GEO_ZIP = new URLSearchParams(window.location.search).get('geoZip') ?? undefined;
